import React from 'react';
import { GetImageMeta as GetImageMetaService } from '../../../../../services/2talk/omnichannel';
import './styles.css'
import AudioPlayer from '../../../../../components/audio-player';
import { PapiroConsole } from '../../../../../utils/papiroConsole';

const AudioLoadingPlaceholder = ({ error }) => (
  <div className={`omnichannel-chat-message-audio-placeholder${error ? ' error' : ''}`}>
    <div className={error ? "omnichannel-chat-message-audio-error-icon" : "omnichannel-chat-message-audio-spinner"}>
      {error ? "!" : null}
    </div>
    {error ? (
      <span className="omnichannel-chat-message-audio-error-text">Áudio indisponível</span>
    ) : (
      <div className="omnichannel-chat-message-audio-waveform">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    )}
  </div>
)

function ChatMessageAudio({ id, setLoading }) {
  const [src, setSrc] = React.useState("")
  const [loadingAudio, setLoadingAudio] = React.useState(true)
  const [audioError, setAudioError] = React.useState(false)
  
  React.useEffect(() => {
    let active = true

    const getAudioLink = async () => {
      try {
        setLoadingAudio(true)
        setAudioError(false)
        setLoading(true)
        let result = await GetImageMetaService(id)
        PapiroConsole.log("result getAudioLink")
        PapiroConsole.log(result)
        if (active && result && result.success && result.data && result.data.url) {
          PapiroConsole.log("entrei src getAudioLink")
          setSrc(result.data.url)
        } else if (active) {
          setAudioError(true)
        }
      } catch (error) {
        if (active) {
          PapiroConsole.log("erro getAudioLink")
          PapiroConsole.log(error)
          setAudioError(true)
        }
      } finally {
        if (active) {
          setLoadingAudio(false)
          setLoading(false)
        }
      }
    }

    if (!id) {
      setSrc("")
      setAudioError(false)
      setLoadingAudio(true)
      return () => {
        active = false
      }
    }

    if (id) {
      setSrc("")
      PapiroConsole.log("ENTREI NO ID AQUI getAudioLink")
      PapiroConsole.log(id)
      getAudioLink()
    }

    return () => {
      active = false
    }
  }, [id, setLoading]);

  return (<div className="omnichannel-chat-message-audio" >
    <div className="omnichannel-chat-message-audio-name" >
      {audioError ? <AudioLoadingPlaceholder error /> : src.length > 0 ? <AudioPlayer audioUrl={src} /> : loadingAudio && <AudioLoadingPlaceholder />}
    </div>
  </div>)
};

export default ChatMessageAudio;
